import React, { useEffect, useState } from 'react'
import Selector from './../../Components/Select/Select'
import { getReportType } from './../../Service/report'
import { report } from './../../store/report'
import { observer } from 'mobx-react-lite'
import { SelectType } from '../../store/models'
import http from './../../Service/http'
import { direction } from '../../store/direction'

function ApplicationsExpect() {
	const [reportType, setReportType] = useState<SelectType>({
		label: 'Все',
		value: 0
	})

	const getReport = async () => {
		const res = await getReportType()
		report.newReportTypes(res)
	}
	useEffect(() => {
		getReport()
	}, [])
	const getReports = async (id: number) => {
		const a = await http.post('/report/reportApplicationWait?reportType=' + id)

		report.newReport(a.data.reportApplicationWait)
	}
	useEffect(() => {
		getReports(reportType.value)
		report.newType(reportType.value)
	}, [reportType])

	useEffect(() => {
		getReports(reportType.value)
		report.newType(reportType.value)
	}, [direction.leftOrRight])

	return (
		<>
			<div style={{ margin: '0 auto', width: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
				<Selector
					options={[
						{
							value: 0,
							label: 'Все'
						},
						...report.reportTypes
					]}
					value={reportType}
					placeholder={'Выберите!'}
					onChange={setReportType}
					isSearchable={true}
					isDisabled={false}
					isClearable={false}
					title={''}
					name={'search'}
					withBorder={true}
				/>
			</div>
		</>
	)
}

export default observer(ApplicationsExpect)
